import { useEffect } from 'react'
import { safeSessionStorage } from 'ui'

type ErrorResponse = {
  status?: number
  message?: string
  response?: { status?: number }
} | null

export const RETRY_COUNT_KEY = 'retryCount'
const DEFAULT_RETRY_LIMIT = 3
const DEFAULT_ERROR_CODE = 502
const BAD_GATEWAY_TEXT = '502 Bad Gateway'

export function useRetryOnError(
  error: ErrorResponse,
  retryLimit: number = DEFAULT_RETRY_LIMIT,
  errorCode: number = DEFAULT_ERROR_CODE,
): void {
  useEffect(() => {
    if (error) {
      if (typeof window !== 'undefined' && safeSessionStorage.isStorageAvailable()) {
        const errorStatus = error.status || error.response?.status || null
        const isBadGatewayMessage = error.message?.includes(BAD_GATEWAY_TEXT) || false

        if (errorStatus === errorCode || isBadGatewayMessage) {
          const retryCount = parseInt(safeSessionStorage.getItem(RETRY_COUNT_KEY) || '0', 10)

          if (retryCount < retryLimit) {
            safeSessionStorage.setItem(RETRY_COUNT_KEY, (retryCount + 1).toString())
            window.location.reload()
          }
        } else {
          safeSessionStorage.removeItem(RETRY_COUNT_KEY)
        }
      }
    }
  }, [error, retryLimit, errorCode])
}
